<template>
  <div class="animated fadeIn">
    <b-container fluid class="pt-3 pt-lg-3 pt-md-3 pb-3 pb-lg-3 pb-md-3">
      <b-row>
        <b-col>
          <b-card class="border-0 rounded">
            <div class="card-title w-100 mx-auto text-center py-3 py-lg-3 py-md-3">
              <span class="h4 font-weight-bold line-height-gold text-center text-dark">Hej, partnerName</span>
            </div>
            <div class="py-2 py-lg-2 py-md-2"></div>
            <div class="card-text text-center mx-auto">
              <div class="h6 open-sans line-height-golden">
                Da dette er den første gang, du logger ind på din personlige partnerprofil, beder vi dig om at tjekke, at vi har registreret de rigtige oplysninger om dig, dit firma og dine præferencer.
              </div>
              <div class="h6 open-sans line-height-golden">
                Hvis du finder en fejl kan du hurtigt og nemt rette den med det samme og komme godt i gang med dit partnerskab.
              </div>
              <div class="h6 open-sans line-height-golden">
                Vi håber, du får en masse gode kundemøder ud af vores service!
              </div>
            </div>
            <form-wizard @on-complete="onComplete" stepSize="lg" back-button-text="Tilbage" next-button-text="Næste" finish-button-text="End" title="" subtitle="" color="rgba(44, 62, 80,1.0)">
              <tab-content>
                <div class="animated fadeIn d-flex justify-content-start">
                  <b-form class="mx-auto mb-4 mb-lg-4 mb-md-4">
                    <fieldset>
                      <b-form-row>
                        <b-col>
                          <b-form-group label="CVR" class="font-weight-bold">
                            <b-input placeholder="cvr" class="rounded bg-light"></b-input>
                          </b-form-group>
                        </b-col>
                      </b-form-row>
                      <!-- contactName and firmaname-->
                      <b-form-row>
                        <b-col lg="6">
                          <b-form-group label="Kontaktperson" class="font-weight-bold">
                            <b-input placeholder="Kontaktperson" class="rounded bg-light"></b-input>
                          </b-form-group>
                        </b-col>
                        <b-col lg="6">
                          <b-form-group label="Firmanavn" class="font-weight-bold">
                            <b-input placeholder="Firmanavn" class="rounded bg-light"></b-input>
                          </b-form-group>
                        </b-col>
                      </b-form-row>
                      <!-- email and telefon-->
                      <b-form-row>
                        <b-col lg="6">
                          <b-form-group label="Email" class="font-weight-bold">
                            <b-input placeholder="Email" class="rounded bg-light"></b-input>
                          </b-form-group>
                        </b-col>
                        <b-col lg="6">
                          <b-form-group label="Telefon" class="font-weight-bold">
                            <b-input placeholder="Telefon" class="rounded bg-light"></b-input>
                          </b-form-group>
                        </b-col>
                      </b-form-row>
                      <!-- email and telefon-->
                      <b-form-row>
                        <b-col lg="6">
                          <b-form-group label="Postnummer" class="font-weight-bold">
                            <b-input placeholder="Postnummer" class="rounded bg-light"></b-input>
                          </b-form-group>
                        </b-col>
                        <b-col lg="6">
                          <b-form-group label="By" class="font-weight-bold">
                            <b-input placeholder="By" class="rounded bg-light"></b-input>
                          </b-form-group>
                        </b-col>
                      </b-form-row>
                      <b-form-row>
                        <b-col class="py-3 py-lg-3 py-md-3">
                          <b-btn variant="success" class="rounded font-weight-bold" size="lg">
                            <span class="mr2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.004 3h2.996v5h-2.996v-5zm8.996 1v20h-24v-24h20l4 4zm-19 5h14v-7h-14v7zm16 4h-18v9h18v-9zm-2 2h-14v1h14v-1zm0 2h-14v1h14v-1zm0 2h-14v1h14v-1z"/></svg></span>
                            <span>Gem</span>
                          </b-btn>
                        </b-col>
                      </b-form-row>
                      <b-form-row>
                        <b-col>
                          <b-form-group label="Adresse" class="font-weight-bold">
                            <b-input placeholder="Adresse" class="rounded bg-light"></b-input>
                          </b-form-group>
                        </b-col>
                      </b-form-row>
                    </fieldset>
                  </b-form>
                </div>
              </tab-content>
              <tab-content>
                <div class="animated fadeIn d-flex justify-content-center">
                  <b-form>
                    <fieldset>
                      <b-form-row class="px-4 py-4">
                        <b-col lg="4" md="4" sm="6" v-for="item in items" :key="item.id" v-if="item.parent_id === '1' || item.parent_id === '32'">
                          <b-form-group>
                            <b-form-checkbox @change="toggleAll(item.id)" :disabled="item.valid !== 1" v-model="selected" :value="item.id" :id="'checkbox' + item.id" unchecked-value="not_accepted" class="text-dark font-weight-bold" style="font-size:11.5px;">
                              <span>{{ item.name.replace(' / Fagbooking.dk', '').replace('/ fagbooking.dk', '') }}</span>
                            </b-form-checkbox>
                            <div class="py-1"></div>
                            <b-collapse class="p-2 p-lg-2 p-md-2" :id="item.id">
                              <b-form-group v-for="subitem in items" :key="subitem.id" v-if="subitem.parent_id === item.id" :disabled="subitem.valid !== 1">
                                <b-form-checkbox :id="subitem.id" v-model="selected" :value="subitem.id" unchecked-value="not_accepted" style="font-size:11.5px;">{{ subitem.name.replace(' / Fagbooking.dk', '').replace('/ fagbooking.dk', '') }}
                                </b-form-checkbox>
                              </b-form-group>
                            </b-collapse>
                          </b-form-group>
                        </b-col>
                      </b-form-row>
                      <b-form-row>
                        <b-col class="text-center my-4">
                          <b-btn v-if="showimentor" size="lg" class="mx-auto rounded font-weight-bold" variant="success" @click="opgave_action()">
                            <span class="mr2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.004 3h2.996v5h-2.996v-5zm8.996 1v20h-24v-24h20l4 4zm-19 5h14v-7h-14v7zm16 4h-18v9h18v-9zm-2 2h-14v1h14v-1zm0 2h-14v1h14v-1zm0 2h-14v1h14v-1z"/></svg></span>
                            <span>Gem opgavetyper</span>
                          </b-btn>
                        </b-col>
                      </b-form-row>
                    </fieldset>
                  </b-form>
                </div>
              </tab-content>
            </form-wizard>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: 'setup',
  components: {},
  props: {
  },
  data () {
    return {
      items: [],
      showimentor: true,
      show: false,
      label: 'Loading...',
      overlay: 1,
      selected: [],
      loading: true
    }
  },
  methods: {
    onComplete: function () {
      alert('Your settings are now saved.')
    },
    toggleAlarmpris (checked) {
      this.form.alarmpris.selected = checked ? this.form.alarmpris.choices.slice() : []
    },
    opgave_action () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      if (this.selected.length === 0) {
        this.modalShowDato = false
        // this.loading = false
        let obj = {
          title: 'Gennemført!',
          message: '',
          type: 'danger'
        }
        this.$refs.simplert.openSimplert(obj)
        return
      }
      var dataPartner = {operation: 'producttask', salesPerson: this.salesPerson, category: this.selected}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            // this.loading = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              // this.loading = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    toggleAll (item) {
      if ($('#checkbox' + item).is(':checked')) {
        $('#' + item).show()
        for (var Subitem in this.items) {
          if (this.items[Subitem].parent_id === item) {
            this.selected.push(this.items[Subitem].id)
          }
        }
      } else {
        $('#' + item).hide()
        for (var Subitem1 in this.items) {
          if (this.items[Subitem1].parent_id === item) {
            this.removeItem(this.selected, this.items[Subitem1].id)
          }
        }
      }
    },
    removeItem (array, item) {
      for (var i in array) {
        if (array[i] === item) {
          array.splice(i, 1)
          break
        }
      }
    },
    firstSelected () {
      for (var i in this.selected) {
        $('#' + this.selected[i]).show()
      }
    },
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson}
      if (localStorage.getItem('imentor') === '0') {
        this.showimentor = false
        this.loading = false
        return
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.loading = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res.subpartnerjob
            if (res.dataObjselect instanceof Array) {
              this.selected = res.dataObjselect
            }
            setTimeout(() => this.firstSelected(), 400)
          },
          response => {
            alert('error')
          }
        )
    },
    toggleElektrikerpris (checked) {
      this.form.elektrikerpris.selected = checked ? this.form.elektrikerpris.choices.slice() : []
    },
    toggleGaragepris (checked) {
      this.form.garagepris.selected = checked ? this.form.garagepris.choices.slice() : []
    },
    toggleGulvpris (checked) {
      this.form.gulvpris.selected = checked ? this.form.gulvpris.choices.slice() : []
    },
    // onSubmit (evt) {
    //   evt.preventDefault()
    //   alert(JSON.stringify(this.form))
    // },
    onReset (evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.alarmprisTypes = ''
      // this.form.name = ''
      // this.form.food = null
      // this.form.checked = []
    }
  }
}
</script>
<style>
.wizard-header {
  height:0;
  padding:0!important;
}
.wizard-title {
  font-weight:700!important;
}
.wizard-icon-circle {
  background: #fff!important;
  color: #000!important;
}
.wizard-footer-left > .wizard-button {
  background: yellow!important;
}
</style>


// WEBPACK FOOTER //
// PartnerSetup.vue?50486674